import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import HotPicks from './components/HotPicks';
import Categories from './components/Categories';
import Ranking from './components/Ranking';
import Latest from './components/Latest';
import Faq from './components/Faq';
import About from './components/About';

export default function Home() {
  const [query, setQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('全部');
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handlePickCategory = (category: string) => {
    setActiveCategory(category);
    document.getElementById('latest')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero
          query={query}
          setQuery={setQuery}
          onPickCategory={handlePickCategory}
        />
        <HotPicks />
        <Categories onPickCategory={handlePickCategory} />
        <Ranking />
        <Latest
          query={query}
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
        />
        <Faq />
        <About />
      </main>
      <Footer />

      <button
        type="button"
        aria-label="返回顶部"
        onClick={scrollTop}
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm transition-all duration-300 hover:bg-primary-600 ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-lg" />
      </button>
    </div>
  );
}